import { render, staticRenderFns } from "./LevelsSection.vue?vue&type=template&id=1458620f&scoped=true&"
import script from "./LevelsSection.vue?vue&type=script&lang=js&"
export * from "./LevelsSection.vue?vue&type=script&lang=js&"
import style0 from "./LevelsSection.vue?vue&type=style&index=0&id=1458620f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1458620f",
  null
  
)

export default component.exports